import React from 'react';
import '../../../styles/containers/Prayer/components/remember-god-choice.scss';

function RememberGodChoice({setRememberChoice}) {
    
    const handleClick = () => {
        setRememberChoice(prev => {
            return !prev;
        });
    }
    return (
        <div className='d-flex justify-content-center align-items-center remember-god-choice-container'>
       <input className='__checkbox' type="checkbox" id="remember-choice" name="remember-choice" value="No" onClick={handleClick}/>
            <div className='__checkbox-text'>Remember My Choice</div><br></br>
        </div>
    )
}

export default RememberGodChoice
